import { render, staticRenderFns } from "./PageBlogCategory.vue?vue&type=template&id=0a880808&scoped=true&"
import script from "./PageBlogCategory.vue?vue&type=script&lang=js&"
export * from "./PageBlogCategory.vue?vue&type=script&lang=js&"
import style0 from "./PageBlogCategory.vue?vue&type=style&index=0&id=0a880808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a880808",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ohid/instaprivat/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a880808')) {
      api.createRecord('0a880808', component.options)
    } else {
      api.reload('0a880808', component.options)
    }
    module.hot.accept("./PageBlogCategory.vue?vue&type=template&id=0a880808&scoped=true&", function () {
      api.rerender('0a880808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/blog/PageBlogCategory.vue"
export default component.exports